import { render, staticRenderFns } from "./CadastroLoja.vue?vue&type=template&id=2907f39c"
import script from "./CadastroLoja.vue?vue&type=script&lang=js"
export * from "./CadastroLoja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports